import { Component, RefObject } from 'react';
import './CheckBox.css';
import React from 'react';
import { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { pink, blue } from '@mui/material/colors';


interface CheckBoxProps {
  id: string;
  checked?: boolean;
  onClick(checked: boolean): void;
}


const CheckBox: React.FC<CheckBoxProps> = ({ id, checked, onClick }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const onChangeHandler = () => {
    const newState = !isChecked;
    setIsChecked(newState);
    onClick(newState);
  }

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  return (
    <div className="checkbox-container" id={id}>
      <Checkbox {...label} onChange={onChangeHandler}
        sx={{
          color: blue[800],
          '&.Mui-checked': {
            color: blue[800],
          },
        }}
      />
    </div>
  )
}


export default CheckBox;